import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";

const STORAGE_KEY = "autopiecemalin_cookie_consent_v1";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() }),
      );
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-800/80 bg-slate-950/95 backdrop-blur-xl shadow-[0_-20px_60px_-20px_rgba(0,0,0,0.8)]"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:gap-6 sm:px-8">
        <div className="flex shrink-0 items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-cyan-500/15 ring-1 ring-cyan-500/30">
            <Cookie className="h-5 w-5 text-cyan-300" />
          </div>
        </div>

        <div className="flex-1 text-sm text-slate-300">
          <p className="font-semibold text-slate-100">
            Autopièce Malin respecte ta vie privée
          </p>
          <p className="mt-1 text-xs leading-relaxed text-slate-400 sm:text-sm">
            Nous utilisons des cookies de fonctionnement et des cookies
            d'affiliation (pour attribuer un achat chez un partenaire). Aucun
            cookie publicitaire tiers. Tu peux les accepter ou les refuser.{" "}
            <Link
              to="/politique-confidentialite"
              data-testid="cookie-banner-policy-link"
              className="text-cyan-400 underline-offset-2 hover:text-cyan-300 hover:underline"
            >
              En savoir plus
            </Link>
          </p>
        </div>

        <div className="flex flex-wrap gap-2 sm:flex-nowrap">
          <Button
            data-testid="cookie-refuse-button"
            variant="outline"
            size="sm"
            onClick={() => persist("refused")}
            className="gap-2 border-slate-700 bg-slate-900/70 text-slate-200 hover:border-cyan-500/50 hover:bg-slate-800 hover:text-cyan-300"
          >
            <X className="h-3.5 w-3.5" />
            Refuser
          </Button>
          <Button
            data-testid="cookie-accept-button"
            size="sm"
            onClick={() => persist("accepted")}
            className="bg-cyan-500 font-semibold text-slate-950 hover:bg-cyan-400"
          >
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};
